import type { FrontModule } from "@nabble/sdk";
import { lazy } from "react";

const BoardsPage = lazy(() => import("./pages/BoardsPage"));
const BoardPage = lazy(() => import("./pages/BoardPage"));

export const projectManagerModule: FrontModule = {
  id: "project-manager",
  version: "0.2.0",
  permission: "project-manager.read",
  label: "Project Manager",
  icon: "columns",
  description: "Organize your teams' work on Kanban boards with columns, cards, assignees and due dates.",
  routes: [
    { path: "/project-manager", Component: BoardsPage },
    { path: "/project-manager/boards/:boardId", Component: BoardPage },
  ],
  menu: [
    {
      id: "project-manager.boards",
      label: "Boards",
      icon: "columns",
      path: "/project-manager",
      permission: "project-manager.read",
      description: "Your work boards",
    },
  ],
};

export default projectManagerModule;
